import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  push,
  set,
  update,
  get,
  child,
} from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC7Goy3F9hzkciReYtQkj4R7J30F72J5Bc",
  authDomain: "taskapp-c71bc.firebaseapp.com",
  databaseURL: "https://taskapp-c71bc-default-rtdb.firebaseio.com",
  projectId: "taskapp-c71bc",
  storageBucket: "taskapp-c71bc.appspot.com",
  messagingSenderId: "1066846342812",
  appId: "1:1066846342812:web:5c0b030708c77e05686759",
};

const app = initializeApp(firebaseConfig);

const db = getDatabase(app);

export { app, db, ref, push, set, update, get, child };
